import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { isPlatformAdminUser } from '../auth/routing.js';
import { PlatformAccessDeniedPage } from '../pages/platform/PlatformAccessDeniedPage.js';

interface Props {
  children: React.ReactNode;
}

export function PlatformProtectedRoute({ children }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="page-loading">
        <div className="spinner" aria-hidden />
        <p>Loading your session…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isPlatformAdminUser(user)) {
    return <PlatformAccessDeniedPage />;
  }

  return children;
}
